import { Fragment, type ReactNode } from 'react';
import { parseLegacyRichText, type LegacyRichTextNode } from './legacyRichText.utils';

interface LegacyRichTextProps {
  allowLinks?: boolean;
  value: string;
}

const renderInlineNode = (node: LegacyRichTextNode, key: number): ReactNode => {
  if (typeof node === 'string') return node;
  if (node.kind === 'break') return <br key={key} />;
  const children = node.children.map(renderInlineNode);
  switch (node.kind) {
    case 'strong':
      return (
        <strong key={key} className="font-bb">
          {children}
        </strong>
      );
    case 'em':
      return <em key={key}>{children}</em>;
    case 'u':
      return <u key={key}>{children}</u>;
    case 'link':
      return (
        <a key={key} href={node.href} className="text-primary-purple underline">
          {children}
        </a>
      );
    default:
      return <Fragment key={key}>{children}</Fragment>;
  }
};

export default function LegacyRichText({ allowLinks = false, value }: LegacyRichTextProps) {
  return <>{parseLegacyRichText(value, allowLinks).map(renderInlineNode)}</>;
}
